import React from 'react';
import {
  AppBar,
  Tabs,
  Tab,
  Box,
  // Typography,
  useTheme,
  Grid,
  TableContainer,
  Paper,
  Table,
  // TableHead,
  TableRow,
  TableCell,
  TableBody,
  makeStyles,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import RecallErrorMessage from './RecallErrorMessage';

const useStyle = makeStyles((theme) => ({
  appBar: {
    borderRadius: 10,
    maxWidth: 600,
    margin: '0 auto'
  },
  tabContainer: {
    [theme.breakpoints.only('xs')]: {
      padding: 10,
    },
    paddingLeft: 5,
    paddingRight: 5,
  },
  tableTitle: {
    fontSize: 22,
  },
  summaryContainer: {
    boxShadow: theme.shadows[2],
    width: '100%',
    borderRadius: 20,
  },
  imageTableContainer: {
    borderRadius: 20,
  },
  cardImage: {
    width: "100%",
    maxHeight: "800px",
    objectFit: "contain"
  },
  iFrame: {
    height: 400,
    overflow: "hidden"
  },
}));

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  const classes = useStyle();

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} className={classes.tabContainer}>
          <Grid container>{children}</Grid>
        </Box>
      )}
    </div>
  );
};

const RecallTabs = (props) => {
  const { recall, tabValue, handleTabChange, handleChangeIndex, handleImgClicked } = props;
  //const [loading] = useState(true);

  const theme = useTheme();
  const classes = useStyle();

  return (
    <>
      <AppBar position="static" color="secondary" className={classes.appBar}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          {/* <Tab label="Quick Facts" /> */}
          <Tab label="Summary" />
          <Tab label="Images" />
          { recall.hasMaps() && (<Tab label={recall.getMapURLs().length > 1 ? "Cases" : "Map"} />) }
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis="x"
        index={tabValue}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={tabValue} index={0} dir={theme.direction}>
          <List component="nav" className={classes.summaryContainer}>
            {recall.getTileSummaries() !== undefined ? (
              recall.getTileSummaries().map((item, index) => (
                <ListItem key={index}>
                  <ListItemText
                    primary={item.name}
                    secondary={item.summary}
                  />
                </ListItem>
              ))
            ) : (
              <RecallErrorMessage />
            )}
          </List>
        </TabPanel>
        <TabPanel value={tabValue} index={1} dir={theme.direction}>
              <TableContainer component={Paper} className={classes.imageTableContainer}>
                <Table>
                  <TableBody>
                    {
                      recall.hasProductImages() ?
                      recall.getProductImages().map((imageURL, index) => (
                        <TableRow key={index}>
                          {/* <TableCell align="center">Image {index+1}</TableCell> */}
                          <TableCell align="center">
                            {
                              imageURL.includes('.pdf') ? (
                                <iframe title={imageURL} className={classes.iFrame} src={`${imageURL}#toolbar=0`} />
                              ) :
                                (
                                  <img className={classes.cardImage}
                                    src={imageURL}
                                    loading="lazy"
                                    alt="product"
                                    data-index={index}
                                    onClick={handleImgClicked}
                                  />
                                )
                            }
                          </TableCell>
                        </TableRow>
                      )) :
                      <TableRow key={1}>
                          <TableCell align="center">
                            No images found.
                          </TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
        </TabPanel>
        <TabPanel value={tabValue} index={2} dir={theme.direction}>
            <TableContainer component={Paper} className={classes.imageTableContainer}>
              <Table>
                <TableBody>
                  {
                      recall.hasMaps() ?
                      recall.getMapURLs().map((imageURL, index) => (
                        <TableRow key={index}>
                          {/* <TableCell align="center">Image {index+1}</TableCell> */}
                          <TableCell align="center">
                            {
                              <img className={classes.cardImage}
                                src={imageURL}
                                loading="lazy"
                                alt="map"
                                data-index={recall.getProductImages().length + index}
                                onClick={handleImgClicked}
                              />
                            }
                          </TableCell>
                        </TableRow>
                      )) :
                      <TableRow key={1}>
                          <TableCell align="center">
                            No maps found.
                          </TableCell>
                      </TableRow>
                    }
                </TableBody>
              </Table>
            </TableContainer>
        </TabPanel>
      </SwipeableViews>
    </>
  );
};

export default RecallTabs;
